import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"dense":"","align":"center","justify":"center"}},_vm._l((_vm.dices),function(dice){return _c(VCol,{key:dice.id,staticClass:"d-flex justify-center",attrs:{"cols":"3"}},[_c('Dice',{attrs:{"dice":dice},on:{"set-selected":function($event){return _vm.$emit('set-selected', dice.id)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }